const NUMBER_REGEX = /\d/;
const SPECIAL_CHARACTER_REGEX = /[~!@#$%^&*_\-+=`|(){}[\]:";'<>,.?/]/;
const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;

export const getPasswordValidation = (password = '') => ({
  minLength: password.length >= 8,
  lowerCase: LOWERCASE_REGEX.test(password),
  upperCase: UPPERCASE_REGEX.test(password),
  number: NUMBER_REGEX.test(password),
  specialCharacter: SPECIAL_CHARACTER_REGEX.test(password)
});

const validate = (password = '') => Object.values(getPasswordValidation(password)).every(Boolean);

export default validate;
